import { VLL } from '@geeqdev/geeq_capnp_ts/generated/vll.capnp';

import { Storage } from 'geeq_node_core/src/storage/interfaces';
import {
  ValidationLayerLedgerWrapper,
} from 'geeq_node_core/src/capnp/wrappers/validation-layer-ledger';

export class VllStorage implements Storage<ValidationLayerLedgerWrapper, VLL> {
  private cacheSize = 10000;

  private wrappers = new Array<ValidationLayerLedgerWrapper>();

  public async clearCache(): Promise<boolean> {
    this.wrappers = [];

    return true;
  }

  public async getCurrentBlock(): Promise<VLL> {
    return this.wrappers[0].getMessage();
  }

  public async getCurrentWrapper(): Promise<ValidationLayerLedgerWrapper> {
    return this.wrappers[0];
  }

  public async isEmpty(): Promise<boolean> {
    return this.wrappers.length === 0;
  }

  public async save(wrapper: ValidationLayerLedgerWrapper): Promise<boolean> {
    if (this.wrappers.length >= this.cacheSize) {
      this.wrappers.pop();
    }

    this.wrappers.unshift(wrapper);

    return true;
  }

  public setCacheSize(size: number): void {
    this.cacheSize = size;
  }
}
